export default {
  setSPCMFireflies (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("setSPCMFireflies", payload)
      resolve()
    })
  }
}
